<template>
  <v-app>
    <v-main>
      <Header v-if="!$route.meta.hideNavFooter" />
      <router-view />
      <Footer v-if="!$route.meta.hideNavFooter" />
      <GoTop v-if="!$route.meta.hideNavFooter" />
      <router-link v-if="!$route.meta.hideNavFooter && $route.name !== 'MoroccoGateway'" to="/morocco-gateway" class="morocco-fab">
        <i class="fa fa-globe-africa"></i>
        <span>{{ $t('MoroccoGatewayLabel') }}</span>
        <i class="fa fa-arrow-right morocco-fab__arrow"></i>
      </router-link>
    </v-main>
  </v-app>
</template>

<script>
import GoTop from './components/Layout/GoTop.vue';
import Header from './components/Layout/Header.vue';
import Footer from './components/Layout/Footer.vue';

export default {
  name: "App",
  components: {
    Header,
    Footer,
    GoTop
  },
};
</script>

<style>
/* Reset Vuetify overrides to match original theme */
html {
  font-family: var(--qutiiz-font, "Rubik", sans-serif) !important;
  font-size: 16px !important;
  line-height: 1.5 !important;
}
body {
  font-family: var(--qutiiz-font, "Rubik", sans-serif) !important;
  font-size: 1rem !important;
}
.v-application {
  font-family: inherit !important;
  line-height: inherit !important;
}

.get-to-know__img:after {
  display: none;
}
.get-to-know__img,
.get-to-know__img img {
  border-radius: 8px !important;
}
.why-choose-one__bottom-img img {
  border-radius: 8px !important;
}
.page-header__inner h2 {
  text-align: center;
}
section.counter-one {
  background-color: #6222cc;
}
.cta-one__inner {
  background-color: #38393b !important;
}
.main-menu-wrapper__logo img {
  height: auto;
  width: 125px;
}
@media (max-width: 991.98px) {
  .v-divider-h {
    display: none;
  }
  .Navitem-cont {
    padding: 0 15px !important;
  }
}
@media (max-width: 767px) {
  /* Footer columns stack */
  .site-footer__top .row .col-25,
  .site-footer__top .row > div {
    flex: 0 0 100% !important;
    max-width: 100% !important;
    margin-bottom: 20px;
    text-align: center;
  }
  .site-footer__top-logo img {
    width: 180px !important;
  }
  /* Page header */
  .page-header__inner h2 {
    font-size: 28px !important;
  }
  /* CTA brochure section */
  .cta-one__inner {
    flex-direction: column !important;
    text-align: center;
  }
  .cta-one__left,
  .cta-one__right {
    width: 100% !important;
    text-align: center !important;
  }
  .cta-one__title {
    font-size: 22px !important;
    margin-bottom: 20px !important;
  }
  /* General overflow fix */
  body, html {
    overflow-x: hidden !important;
  }
}

/* Morocco Floating Button */
.morocco-fab {
  position: fixed;
  bottom: 100px;
  left: 30px;
  background: #0d5e37;
  color: #fff !important;
  padding: 12px 22px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none !important;
  box-shadow: 0 4px 15px rgba(13, 94, 55, 0.4);
  z-index: 999;
  transition: all 0.3s ease;
  direction: ltr;
}
.morocco-fab:hover {
  background: #094a2b;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(13, 94, 55, 0.5);
}
.morocco-fab__arrow {
  font-size: 12px;
  transition: transform 0.3s ease;
}
.morocco-fab:hover .morocco-fab__arrow {
  transform: translateX(4px);
}
@media (max-width: 767px) {
  .morocco-fab {
    bottom: 80px;
    left: 15px;
    padding: 10px 16px;
    font-size: 12px;
  }
}

/* ===== RTL Support ===== */
html[dir="rtl"] {
  font-family: "Cairo", "Rubik", sans-serif !important;
  direction: rtl;
}
html[dir="rtl"] body {
  font-family: "Cairo", "Rubik", sans-serif !important;
  text-align: right;
  direction: rtl;
}

/* Flip text-left to text-right in RTL */
html[dir="rtl"] .text-left {
  text-align: right !important;
}

/* Section titles */
html[dir="rtl"] .section-title {
  text-align: right;
}
html[dir="rtl"] .section-title.text-center {
  text-align: center !important;
}

/* Main slider content */
html[dir="rtl"] .main-slider__content {
  text-align: right;
  direction: rtl;
}
html[dir="rtl"] .main-slider .owl-carousel .owl-dots {
  left: auto !important;
  right: 15px !important;
  text-align: right !important;
}

/* Menu items */
html[dir="rtl"] .main-menu__list {
  direction: rtl;
}
html[dir="rtl"] .menu-item--morocco a i {
  margin-right: 0 !important;
  margin-left: 6px;
}

/* Footer */
html[dir="rtl"] .footer-widget__about-contact li .icon {
  margin-right: 0;
  margin-left: 10px;
}
html[dir="rtl"] .footer-widget__links-list li a {
  text-align: right;
}

/* Contact page */
html[dir="rtl"] .contact-info__title,
html[dir="rtl"] .contact-info__text {
  text-align: right;
}

/* Blog */
html[dir="rtl"] .blog-one__content {
  text-align: right;
}
html[dir="rtl"] .blog-details__content {
  text-align: right;
  direction: rtl;
}
html[dir="rtl"] .sidebar {
  text-align: right;
}
html[dir="rtl"] .blog-details__tags span {
  direction: rtl;
}

/* About & Why Us */
html[dir="rtl"] .get-to-know__right,
html[dir="rtl"] .why-choose-one__right,
html[dir="rtl"] .about-page__right {
  text-align: right;
}
html[dir="rtl"] .why-choose-one__points li .icon {
  margin-right: 0;
  margin-left: 15px;
}

/* Services */
html[dir="rtl"] .services-one__title {
  text-align: right;
}
html[dir="rtl"] .services-one__find-solutions-text,
html[dir="rtl"] .financial-advice__bottom-text {
  text-align: right;
}

/* Tabs content */
html[dir="rtl"] .tabs-content__points li .icon {
  margin-right: 0;
  margin-left: 15px;
}
html[dir="rtl"] .tabs-content__experience-title {
  text-align: right;
}

/* Testimonials */
html[dir="rtl"] .testimonial-one__left {
  text-align: right;
}

/* Breadcrumbs */
html[dir="rtl"] .thm-breadcrumb li {
  direction: rtl;
}

/* CTA / Brochure */
html[dir="rtl"] .cta-one__title {
  text-align: right;
}

/* Counter section */
html[dir="rtl"] .counter-one__text {
  text-align: center;
}

/* Morocco fab - keep on left for RTL too or move to right */
html[dir="rtl"] .morocco-fab {
  left: auto;
  right: 30px;
}
@media (max-width: 767px) {
  html[dir="rtl"] .morocco-fab {
    left: auto;
    right: 15px;
  }
}

/* WhatsApp button */
html[dir="rtl"] .icon-whatsapp-footer {
  right: auto !important;
  left: 8%;
}
@media (max-width: 767px) {
  html[dir="rtl"] .icon-whatsapp-footer {
    left: 9% !important;
    right: auto !important;
  }
}

/* Page header */
html[dir="rtl"] .page-header__inner {
  text-align: center;
}

/* Forms in RTL */
html[dir="rtl"] .comment-one__form input,
html[dir="rtl"] .comment-one__form textarea {
  text-align: right;
}

/* General flex direction fix for icon+text items */
html[dir="rtl"] .morocco-slide__icon-item {
  flex-direction: row-reverse;
}
html[dir="rtl"] .morocco-slide__features span i {
  margin-right: 0;
  margin-left: 5px;
}
html[dir="rtl"] .morocco-slide__btn i {
  margin-left: 0;
  margin-right: 8px;
}

/* Services page */
html[dir="rtl"] .services-two__single {
  text-align: right;
}

/* Morocco survey page */
html[dir="rtl"] section.morocco-survey {
  direction: rtl !important;
}
</style>
